// extracted by css-extract-rspack-plugin
export default {"overlay":"src-modules-desktop-modules-files-integration-components-FileDropzone-FileDropzone-module__overlay-p5GG4J","content":"src-modules-desktop-modules-files-integration-components-FileDropzone-FileDropzone-module__content-rEqxl5","iconWrapper":"src-modules-desktop-modules-files-integration-components-FileDropzone-FileDropzone-module__iconWrapper-dAuSl_","title":"src-modules-desktop-modules-files-integration-components-FileDropzone-FileDropzone-module__title-hdRxB6","subtitle":"src-modules-desktop-modules-files-integration-components-FileDropzone-FileDropzone-module__subtitle-sbHkma"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"overlay\":\"src-modules-desktop-modules-files-integration-components-FileDropzone-FileDropzone-module__overlay-p5GG4J\",\"content\":\"src-modules-desktop-modules-files-integration-components-FileDropzone-FileDropzone-module__content-rEqxl5\",\"iconWrapper\":\"src-modules-desktop-modules-files-integration-components-FileDropzone-FileDropzone-module__iconWrapper-dAuSl_\",\"title\":\"src-modules-desktop-modules-files-integration-components-FileDropzone-FileDropzone-module__title-hdRxB6\",\"subtitle\":\"src-modules-desktop-modules-files-integration-components-FileDropzone-FileDropzone-module__subtitle-sbHkma\"}";
        // 1793874324891
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  